import React, { useContext } from 'react';
import cls from './ImageCard.module.css';
import { EstimateMeasurementsContext } from '../../Context/EstimateMeasurementsContext';
import { findCurrentImage } from '../../../../TemporaryConmonents/Measurements/helpers/findCurrentImage';

export const ImageCard = ({ src, alt, index }) => {
    const { setCurrentUrl, setCurrentIndex, imageList, setIsOpenPrevImage } = useContext(
        EstimateMeasurementsContext
    );

    const onClickImage = () => {
        setIsOpenPrevImage(true);
        setCurrentUrl(findCurrentImage(src, imageList));
        setCurrentIndex(index);
    };
    return (
        <li className={cls.ImageCard} onClick={onClickImage} id={cls.ImageCardEstimateMeasurements}>
            <img src={src} alt={alt} />
        </li>
    );
};
